import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBySportId',
})
export class GroupBySportId implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const group = o.SportId;
          const icon = o.SportName;
          const sno = o.SportNameOriginal;

          groups[group] = groups[group] ? groups[group] : { SportId: group, SportName: icon, SportNameOriginal: sno, eEvents: [] };
          groups[group].eEvents.push(o);
        });
      }

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
